import { Link } from 'react-router-dom';
import { ArrowRightIcon, UserGroupIcon } from '@heroicons/react/24/outline';
import { HomeBuyerVoiceCard } from '../HomeBuyerVoiceCard';
import { HomeLazySection } from '../HomeLazySection';
import { homeCta } from '../homeCtaStyles';
import { HOME_BUYER_TESTIMONIALS, HOME_BUYER_VALUE_PROPS } from '../homeContent';

const FEATURED_VOICES = HOME_BUYER_TESTIMONIALS.slice(0, 3);

export function HomeSocialProofSection() {
  return (
    <HomeLazySection
      className="home-proof-section relative overflow-hidden bg-[#0c0e1a] py-8 text-white md:py-10"
      placeholderMinHeight="320px"
    >
      <div
        className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_80%_55%_at_50%_-20%,rgba(99,102,241,0.2),transparent)]"
        aria-hidden
      />

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <header className="home-proof__header max-w-xl">
          <p className="inline-flex items-center gap-1.5 rounded-full border border-white/10 bg-white/10 px-2.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide">
            <UserGroupIcon className="h-3.5 w-3.5 text-purple-300" />
            Why people choose Qumashi
          </p>
          <h2 className="mt-3 text-2xl font-extrabold tracking-tight md:text-3xl">
            Built for buyers who refuse generic.
          </h2>
          <p className="mt-2 text-sm leading-relaxed text-white/70">
            Premium drops, honest previews—shopping that feels like a brand, not a marketplace.
          </p>
        </header>

        <ul className="home-proof__values mt-5 grid grid-cols-1 gap-2 sm:grid-cols-2 sm:gap-2.5">
          {HOME_BUYER_VALUE_PROPS.map((item) => {
            const Icon = item.icon;
            return (
              <li
                key={item.title}
                className="home-proof-value flex gap-3 rounded-2xl border border-white/10 bg-white/5 p-3.5 sm:p-4"
              >
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl border border-white/10 bg-white/10">
                  <Icon className="h-4 w-4 text-indigo-200" />
                </span>
                <div className="min-w-0">
                  <p className="text-sm font-extrabold leading-snug text-white">{item.title}</p>
                  <p className="mt-1 text-xs leading-relaxed text-white/70 line-clamp-2 sm:line-clamp-none">
                    {item.body}
                  </p>
                </div>
              </li>
            );
          })}
        </ul>

        <div className="home-proof__voices mt-5">
          <div className="mb-2.5 flex items-center justify-between gap-2">
            <p className="text-[10px] font-bold uppercase tracking-wide text-white/45">
              Illustrative buyer stories
            </p>
            <Link
              to="/about"
              className="text-[11px] font-semibold text-white/50 transition-colors hover:text-white"
            >
              More stories
            </Link>
          </div>
          <ul className="grid grid-cols-1 gap-2.5 sm:grid-cols-3">
            {FEATURED_VOICES.map((voice, index) => (
              <li key={`${voice.author}-${voice.location}`}>
                <HomeBuyerVoiceCard voice={voice} index={index} />
              </li>
            ))}
          </ul>
        </div>

        <footer className="home-proof__cta mt-5">
          <Link
            to="/shop"
            className={`${homeCta.secondaryOnDark} !rounded-full !px-5 !py-2.5 !text-sm w-full sm:w-auto`}
          >
            Shop the collection
            <ArrowRightIcon className="ml-2 h-4 w-4" />
          </Link>
        </footer>
      </div>
    </HomeLazySection>
  );
}
